import { APPLICATION_ROUTES } from '@/constants/applicationRoutes';

export function resolveHomeRoute(
  activeScopeCode: string | null,
  platformPermissions: string[]
): string {
  if (activeScopeCode === 'tenant') {
    return APPLICATION_ROUTES.workspaceDashboard;
  }
  if (activeScopeCode === 'client') {
    return APPLICATION_ROUTES.clientPortal;
  }
  if (platformPermissions.length > 0) {
    return APPLICATION_ROUTES.adminDashboard;
  }
  return APPLICATION_ROUTES.accessError;
}
